import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
export function PriceSection() {
  return <section id="precio" className="w-full bg-cream-dark py-20 px-4" data-id="element-71">
      <div className="max-w-4xl mx-auto" data-id="element-72">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-rose-gold/20" data-id="element-73">
          <div className="bg-brown-primary p-6 text-center" data-id="element-74">
            <h2 className="text-2xl md:text-3xl font-serif text-white italic" data-id="element-75">
              Oferta Especial de Lanzamiento
            </h2>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-76">
            <p className="text-lg text-brown-secondary mb-6" data-id="element-77">
              Por menos de lo que cuesta una salida al cine o una orden de tacos
              por app, puedes tener el manual que transformará tu cara para
              siempre.
            </p>

            <div className="flex flex-col items-center justify-center mb-8" data-id="element-78">
              <span className="text-gray-400 line-through text-xl mb-1" data-id="element-79">
                $19.99 USD
              </span>
              <div className="inline-flex items-center gap-2 mb-3" data-id="element-80">
                <span className="bg-rose-gold text-white text-xs font-bold tracking-wider uppercase px-3 py-1 rounded-full" data-id="element-81">
                  -68% OFF
                </span>
              </div>
              <div className="flex items-baseline gap-1" data-id="element-82">
                <span className="text-5xl md:text-7xl font-bold text-brown-primary" data-id="element-83">
                  $6.39
                </span>
                <span className="text-xl text-brown-secondary font-medium" data-id="element-84">
                  USD
                </span>
              </div>
              <p className="text-sm text-brown-secondary/70 mt-2" data-id="element-85">
                Precio de lanzamiento · Por tiempo limitado
              </p>
            </div>

            <ul className="text-left max-w-md mx-auto space-y-4 mb-10" data-id="element-86">
              <li className="flex items-start gap-3" data-id="element-87">
                <CheckIcon className="w-5 h-5 text-rose-gold shrink-0 mt-0.5" data-id="element-88" />
                <span className="text-brown-primary" data-id="element-89">
                  Guía Digital Completa (PDF)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-90">
                <CheckIcon className="w-5 h-5 text-rose-gold shrink-0 mt-0.5" data-id="element-91" />
                <span className="text-brown-primary" data-id="element-92">
                  Lista de Compras de Farmacia
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-93">
                <CheckIcon className="w-5 h-5 text-rose-gold shrink-0 mt-0.5" data-id="element-94" />
                <span className="text-brown-primary" data-id="element-95">
                  Calendario Imprimible de 14 Días
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-96">
                <CheckIcon className="w-5 h-5 text-rose-gold shrink-0 mt-0.5" data-id="element-97" />
                <span className="text-brown-primary" data-id="element-98">
                  Acceso de por vida a actualizaciones
                </span>
              </li>
            </ul>

            <a href="https://pay.hotmart.com/U104512405G" target="_blank" rel="noopener noreferrer" onClick={() => {
            if ((window as any).fbq) {
              ;
              (window as any).fbq('track', 'AddToCart');
            }
          }} className="w-full md:w-auto px-12 py-5 bg-rose-gold hover:bg-rose-dark text-white text-xl font-bold tracking-wide rounded-sm transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 mb-6 inline-block text-center" data-id="element-99">
              ¡QUIERO EMPEZAR MI CAMBIO!
            </a>

            <div className="flex items-center justify-center gap-2 text-sm text-brown-secondary/70" data-id="element-100">
              <ShieldCheckIcon className="w-4 h-4" data-id="element-101" />
              <span data-id="element-102">Pago 100% Seguro y Encriptado</span>
            </div>
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-103">
          <p className="text-brown-secondary italic" data-id="element-104">
            "Mañana mismo podrías empezar tu Día 1."
          </p>
        </div>
      </div>
    </section>;
}